import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-178b2d93"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row border-top" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "row mt-2" }
const _hoisted_4 = { class: "col-9" }
const _hoisted_5 = { class: "col-3 col-cost" }
const _hoisted_6 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-9" }, "Discount for annual", -1))
const _hoisted_8 = { class: "col-3 annual-discount col-cost" }
const _hoisted_9 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_10 = { class: "col-9" }
const _hoisted_11 = { class: "col-3 annual-discount col-cost" }
const _hoisted_12 = { class: "row mt-2 border-top" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-9" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Today's Total")
], -1))
const _hoisted_14 = { class: "col-3 col-cost" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("b", null, " RECURRING " + _toDisplayString(_ctx.plan.code === "otcpro_annual" ? "ANNUAL" : "MONTHLY") + " COST ", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.planSelected?.name), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.planCostFormatted), 1)
    ]),
    (_ctx.annualDiscountFormatted != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.annualDiscountFormatted), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.coupon.code != null && _ctx.coupon.discount != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, "Coupon used: " + _toDisplayString(_ctx.coupon.code), 1),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.couponDiscountFormatted), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("b", null, _toDisplayString(_ctx.totalCostFormatted), 1)
      ])
    ])
  ]))
}